function FakeCrop() {}
FakeCrop.prototype.init = function (items) {
    var selector = '.nt-product-grid .grid__item .grid__image img';
    if (items) {
        var arrayItem = [];
        items.forEach(function (item) {
            arrayItem.push($(item).find('.grid__image img')[0]);
        });
        selector = arrayItem;
    }
    $(selector).fakecrop({
        fill: false,
        widthSelectorParent: ".grid__item .nt-grid-item-inner .nt-product-item-top",
        ratioWrapper: window.images_size
    });
}